// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"Mappings-module__linkButton___rZBWc","loading":"Mappings-module__loading___3jLPC","warningButton":"Mappings-module__warningButton___1HPm-"};